import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const hasAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const navigationHasAccess = router.getCurrentNavigation()?.extras?.state?.['hasAccess'];

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  // Explicit deny (e.g. project card when user cannot view)
  if (navigationHasAccess === false) {
    router.navigate(['/forbidden']);
    return false;
  }

  // Allow when access is granted explicitly or when no state was passed (direct edit links)
  return true;
};
